import { apiGet, apiPost } from '../client';
import {
  IntelligenceReportListResponseSchema,
  IntelligenceReportResponseSchema,
  RequestIntelligenceReportResponseSchema,
  type IntelligenceReport,
  type IntelligenceReportListResponse,
  type RequestIntelligenceReportResponse,
} from '../intelligenceReportSchemas';
import { IntelligenceResponseSchema, type IntelligenceResponse } from '../schemas';

/** Max-tier deterministic briefing, refreshed on demand. */
export function getBusinessIntelligence(): Promise<IntelligenceResponse> {
  return apiGet('/v1/business/intelligence', IntelligenceResponseSchema);
}

const REPORTS_PATH = '/v1/business/intelligence/reports';

/** Newest first, at most 30, plus the owner's month meter when the server can read it. */
export function listIntelligenceReports(): Promise<IntelligenceReportListResponse> {
  return apiGet(REPORTS_PATH, IntelligenceReportListResponseSchema);
}

export async function getIntelligenceReport(id: string): Promise<IntelligenceReport> {
  const response = await apiGet(`${REPORTS_PATH}/${encodeURIComponent(id)}`, IntelligenceReportResponseSchema);
  return response.data;
}

/** The server writes the report; the owner waits for it. A recent one comes back with `reused: true`. */
export function requestIntelligenceReport(): Promise<RequestIntelligenceReportResponse> {
  return apiPost(REPORTS_PATH, RequestIntelligenceReportResponseSchema);
}
